import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RequestWorkshopVerification } from 'api/types';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import useWorkshopQuery from 'hooks/useWorkshopQuery';
import useWorkshopUpdateRequestQuery from 'hooks/useWorkshopUpdateRequestQuery';

async function createVerification(axios: AxiosInstance, dataForEndpoint: RequestWorkshopVerification): Promise<object> {
  const { data } = await axios.post(`${config.apiBaseUrl}/op/v1/workshop-verification-request/request`, dataForEndpoint);
  return data;
}

export default function useCreateWorkshopVerificationMutation({
  workshop_id,
  workshop_update_request_id,
}: {
  workshop_id: number;
  workshop_update_request_id?: number;
}) {
  const queryClient = useQueryClient();
  const axios = useAxios();
  const toast = useToast();

  return useMutation({
    mutationFn: () =>
      createVerification(axios, {
        workshop_id,
        workshop_update_request_id,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: useWorkshopQuery.getKey(workshop_id),
      });
      queryClient.invalidateQueries({
        queryKey: useWorkshopUpdateRequestQuery.getKey(workshop_update_request_id!),
      });
    },
    onError: (error: any) => {
      manageErrorResponse(toast, error.response.data);
    },
  });
}
